import { IconButton } from "@mui/material";
import DataTable from "app/components/DataTable";
import { ThreedotIcon } from "app/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMockVehicleDetail } from "../../data";
import {
  selectVehicleStatusesLoading,
  selectVehicles,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import { VehicleTableRow } from "../../types";
import { useStyles } from "./styles";

const VehicleTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const vehicles = useSelector(selectVehicles);
  const loading = useSelector(selectVehicleStatusesLoading);

  const handleRowClick = (row: VehicleTableRow) => {
    dispatch(
      actions.getVehicleDetailSuccess({
        vehicleId: row.id,
        detail: getMockVehicleDetail(row),
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        id: "menu",
        label: "",
        width: 40,
        align: "center",
        format: () => (
          <IconButton size="small" sx={{ padding: 0 }}>
            <ThreedotIcon />
          </IconButton>
        ),
      },
      {
        id: "generalStatus",
        label: t("VECHILE_STATUS.TABLE.GENERAL_STATUS"),
        minWidth: 100,
        align: "right",
        format: (row) =>
          t(`VECHILE_STATUS.STATUS_VALUES.${row.generalStatus}`),
      },
      {
        id: "plannedFinish",
        label: t("VECHILE_STATUS.TABLE.PLANNED_FINISH"),
        minWidth: 110,
        align: "right",
      },
      {
        id: "inspectionStatus",
        label: t("VECHILE_STATUS.TABLE.INSPECTION_STATUS"),
        minWidth: 110,
        align: "right",
        format: (row) =>
          t(`VECHILE_STATUS.STATUS_VALUES.${row.inspectionStatus}`),
      },
      {
        id: "curtainStatus",
        label: t("VECHILE_STATUS.TABLE.CURTAIN_STATUS"),
        minWidth: 100,
        align: "right",
        format: (row) =>
          t(`VECHILE_STATUS.STATUS_VALUES.${row.curtainStatus}`),
      },
      {
        id: "panelStatus",
        label: t("VECHILE_STATUS.TABLE.PANEL_STATUS"),
        minWidth: 100,
        align: "right",
        format: (row) => t(`VECHILE_STATUS.STATUS_VALUES.${row.panelStatus}`),
      },
      {
        id: "chassisNo",
        label: t("VECHILE_STATUS.TABLE.CHASSIS_NO"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "makeModel",
        label: t("VECHILE_STATUS.TABLE.MAKE_MODEL"),
        minWidth: 110,
        align: "right",
        format: (row) => t(`VECHILE_STATUS.STATUS_VALUES.${row.makeModel}`),
      },
      {
        id: "vehicleType",
        label: t("VECHILE_STATUS.TABLE.VEHICLE_TYPE"),
        minWidth: 100,
        align: "right",
        format: (row) => t(`VECHILE_STATUS.STATUS_VALUES.${row.vehicleType}`),
      },
      {
        id: "customerName",
        label: t("VECHILE_STATUS.TABLE.CUSTOMER_NAME"),
        minWidth: 120,
        align: "right",
        format: (row) =>
          t(`VECHILE_STATUS.STATUS_VALUES.${row.customerName}`),
      },
      {
        id: "entryDate",
        label: t("VECHILE_STATUS.TABLE.ENTRY_DATE"),
        minWidth: 100,
        align: "right",
      },
    ],
    [t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={vehicles}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        onRowClick={handleRowClick}
        isPointerCursor
      />
    </div>
  );
};

export default VehicleTable;
